<!-- @format -->

<template>
	<div class="form-rules-group-container tree box">
		<el-card shadow="never">
			<div v-if="showRule" class="rule-input">条件展示:{{ ruleShow }}</div>
			<el-main style="padding: 5px">
				<el-row>
					<el-button size="small" style="float: right; margin-left: 10px" type="primary" @click="addRules">
						添加规则
					</el-button>
					<el-button size="small" style="float: right; margin-left: 10px" type="primary" @click="addGroup">
						添加分组
					</el-button>
					<el-button
						v-if="showDel"
						size="small"
						style="float: right; margin-left: 10px"
						type="primary"
						@click="delGroup(data, parent)"
					>
						删除分组
					</el-button>
				</el-row>
				<el-row v-if="(data.condition && data.condition.length > 0) || (data.conditions && data.conditions.length > 0)">
					<el-row
						v-if="data.condition && data.conditions && data.condition.length + data.conditions.length > 1"
						class="child"
					>
						<el-radio-group v-model="data.rules" size="small">
							<el-radio-button label="and" value="and"></el-radio-button>
							<el-radio-button label="or" value="or"></el-radio-button>
						</el-radio-group>
					</el-row>
					<template v-for="(item, index) in data.condition" :key="'condition' + index">
						<el-row
							:class="
								data.condition && data.conditions && data.condition.length + data.conditions.length > 1
									? 'child'
									: 'childMargin'
							"
						>
							<el-tree-select
								v-model="item.field"
								size="small"
								placeholder="请选择字段"
								:data="treeData"
								filterable
								default-expand-all
								allow-create
								@change="onChangeField(item)"
							/>
							<el-select
								v-model="item.operator"
								size="small"
								placeholder="请选择操作符"
								style="margin-left: 10px; width: 120px"
							>
								<el-option v-for="obj in getOperator(item)" :key="obj.value" :label="obj.label" :value="obj.value">
								</el-option>
							</el-select>
							<div v-if="selectData && selectData[item.field]" style="width: 180px; margin-left: 10px; height: 30px">
								<el-tree-select
									v-model="item.value"
									style="vertical-align: top; width: 100%"
									size="small"
									placeholder="请选择字段"
									:data="selectData[item.field]"
									filterable
									default-expand-all
								/>
							</div>
							<el-input
								v-else
								v-model="item.value"
								size="small"
								style="width: 180px; margin-left: 10px"
								placeholder="请输入规则"
							/>
							<el-button style="margin-left: 10px" size="small" @click="data.condition.splice(index, 1)">
								删除
							</el-button>
						</el-row>
					</template>
					<template v-for="(_item, index) in data.conditions" :key="'group' + index">
						<el-row class="child not">
							<index
								v-model="data.conditions![index]"
								:parent="data"
								:show-del="true"
								:del-key="index"
								:show-rule="false"
								:tree-data="treeData"
								:select-data="selectData"
								:get-field-operator="getFieldOperator"
							></index>
						</el-row>
					</template>
				</el-row>
			</el-main>
		</el-card>
	</div>
</template>

<script lang="ts" setup>
	import { ElMessage } from 'element-plus';
	import { Rules, getFieldOperator as getDefaultFieldOperator, TreeData, findObjByCode } from './configs';

	interface Props {
		modelValue: Rules; //数据结构
		parent?: Rules; //数据结构
		showDel?: boolean; //删除按钮
		delKey?: Number; //删除的key
		treeData?: TreeData[];
		showRule?: boolean; //是否展示规则
		selectData?: any;
		getFieldOperator?: Function;
	}

	const props = withDefaults(defineProps<Props>(), {
		showRule: true,
		getFieldOperator: getDefaultFieldOperator,
	});

	const emits = defineEmits(['update:modelValue']);

	const data = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emits('update:modelValue', val);
		},
	});

	const ruleShow = computed(() => {
		const string = walk(data.value, false);
		return string.replace(/\|且-且\|/g, '且').replace(/\|或-或\|/g, '或');
	});

	//递归拼接展示值(flag:判断是取选中的value值还是label,false：label,true:value)
	const walk = (obj: any, flag: boolean) => {
		let ret = '';
		const list: any = [];
		if (obj.condition) {
			for (let i = 0; i < obj.condition.length; i++) {
				const item = obj.condition[i];
				list.push({ textValue: setTextValue(item, flag) });
			}
		}
		if (obj.conditions) {
			for (let i = 0; i < obj.conditions.length; i++) {
				const item = obj.conditions[i];
				const out = walk(item, flag);
				if (out !== undefined) {
					list.push(out);
				}
			}
		}
		for (let i = 0; i < list.length; i++) {
			if (ret !== '') {
				//避免和字段值重复，先设置|且-且|||或-或|，后续处理完成后替换
				const rule = obj.rules === 'and' ? '|且-且|' : '|或-或|';
				ret += ` ${rule} `;
			}
			if (typeof list[i] === 'string') {
				if (`${list[i]}`.includes('|且-且|') || `${list[i]}`.includes('|或-或|')) {
					ret += `(${list[i]})`;
				} else {
					ret += list[i];
				}
			} else {
				ret += list[i].textValue;
			}
		}
		return ret;
	};
	const setTextValue = (condition: any, flag: boolean) => {
		const { field, operator, value } = condition;
		if (flag) {
			const textValue = `${field} ${operator} ${value}`;
			return `(${textValue})`;
		} else {
			const fieldSelect = findObjByCode(field, props.treeData);
			const operatorArr = props.getFieldOperator(fieldSelect?.type);
			const operatorObj = operatorArr && operatorArr.find((val) => val.value === operator);
			//字段名+操作符
			const label =
				(props.selectData && field && props.selectData[field] && findLabelByValue(props.selectData[field], value)) ||
				'';
			const textValue = `${fieldSelect?.label || field || ''} ${operatorObj?.label || ''} ${label ? label : value}`;
			return `(${textValue})`;
		}
	};

	function findLabelByValue(tree, value) {
		for (const node of tree) {
			if (node.value === value) {
				return node.label;
			}
			if (node.children) {
				const label = findLabelByValue(node.children, value);
				if (label) {
					return label;
				}
			}
		}
		return '';
	}
	//删除分组
	const delGroup = (data, parent) => {
		const index = parent.conditions.indexOf(data);
		if (index !== -1) {
			parent.conditions.splice(index, 1);
		}
	};

	const addGroup = () => {
		data.value.conditions?.push({
			rules: 'and',
			condition: [{ field: '', operator: '', value: '' }],
			conditions: [],
		});
	};

	const addRules = () => {
		data.value.condition.push({ field: '', operator: '', value: '' });
	};

	const onChangeField = (item) => {
		item.value = '';
	};

	const getOperator = (condition) => {
		return props.getFieldOperator(findObjByCode(condition.field, props.treeData)?.type);
	};

	const getRuleShow = () => {
		return ruleShow.value;
	};

	const getRuleShowValue = () => {
		const string = walk(data.value, true);
		return string.replace(/\|且-且\|/g, 'and').replace(/\|或-或\|/g, 'or');
	};

	const validate = (obj) => {
		for (let i = 0; i < obj.condition?.length || 0; i++) {
			const item = obj.condition[i];
			if (item.operator === 'empty' || item.operator === '!empty') {
				if (item.field === '' || item.operator === '') {
					ElMessage.error('规则存在未填的选项,请检查。');
					return false;
				}
			} else {
				if (item.field === '' || item.operator === '' || item.value === '') {
					ElMessage.error('规则存在未填的选项,请检查。');
					return false;
				}
			}
		}
		for (let i = 0; i < obj.conditions && obj.conditions.length; i++) {
			const item = obj.conditions[i];
			validate(item);
		}
		return true;
	};

	const validateRule = () => {
		return validate(data.value);
	};

	defineExpose({ getRuleShow, getRuleShowValue, validateRule });
</script>
<style scoped lang="scss">
	.form-rules-group-container {
		width: 100%;

		.rule-input {
			//margin-top: 10px;
			position: relative;
			top: -10px;
		}
		/* 只需要左边边框线 */
		.child {
			width: 100%;
			position: relative;
			border: 1px solid #d9d9d9;
			border-style: none none none solid;
			padding: 5px 0;
			padding-left: 12px;
			//margin-top: 12px;
			flex-wrap: nowrap;
		}

		.childMargin {
			padding: 5px 0;
			flex-wrap: nowrap;
		}

		/* 设置一个伪元素宽2px 高50% 用于遮挡多余的左边框线 */
		.child::before {
			display: block;
			content: '';
			position: absolute;
			background-color: var(--el-card-bg-color);
			width: 1px;
			height: 50%;
		}

		.not::before {
			background: none;
		}

		.not:last-child::before {
			background-color: var(--el-card-bg-color);
		}

		/* 设置第一个子元素的伪类定位 */
		.child:first-child::before {
			left: -1px;
			top: 0;
		}

		/* 设置第二个子元素的伪类定位 */
		.child:last-child::before {
			left: -1px;
			bottom: 0;
		}

		/* 设置子元素的横线，定位在高度的50% */
		.child::after {
			top: 50%;
			left: 0;
			position: absolute;
			content: '';
			display: block;
			width: 10px;
			height: 1px;
			border: 1px solid #d9d9d9;
			border-style: solid none none none;
		}
	}
</style>
